var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuGamesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 74,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 15c-3 2-5 6-3 9l14 33c2 3 5 4 8 3l7-3c1-1 2-2 1-4v-2l7-16 7-15 3-7 1-1-2-3-2-5c-1-3-5-5-9-3L4 15Zm32 5a6 6 0 1 0 0-12 6 6 0 0 0 0 12Zm-16 4a6 6 0 1 1-12 0 6 6 0 0 1 12 0Zm5 29a6 6 0 1 0 0-12 6 6 0 0 0 0 12ZM59 13c-3-1-7 0-9 4L36 49c-2 3 0 8 3 9l32 14c4 2 8 0 9-3l15-32c1-4 0-8-4-9L59 13Zm0 20a6 6 0 1 0 0-12 6 6 0 0 0 0 12Zm12 10a6 6 0 1 1-12 0 6 6 0 0 1 12 0Zm1 22a6 6 0 1 0 0-12 6 6 0 0 0 0 12Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuGamesIcon);
export default __webpack_public_path__ + "static/media/menu-games-icon.85e3e106b607214dd98a316e6351d8d5.svg";
export { ForwardRef as ReactComponent };